import React from 'react';
import { ArrowLeft, Shield } from 'lucide-react';
import { companyInfo } from '../data/companyInfo';

interface PrivacyPolicyPageProps {
  onNavigate: (path: string) => void;
}

export const PrivacyPolicyPage: React.FC<PrivacyPolicyPageProps> = ({ onNavigate }) => {
  return (
    <div className="bg-[#071426] text-[#D5DFEC] py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        
        <button
          onClick={() => onNavigate('/')}
          className="inline-flex items-center gap-2 text-xs font-semibold text-[#8FA0B8] hover:text-white transition-colors"
        >
          <ArrowLeft size={14} />
          <span>Back to Home</span>
        </button>

        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0B2342] text-xs font-semibold uppercase tracking-wider text-[#00C853]">
            <Shield size={14} />
            <span>LEGAL & COMPLIANCE</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white font-display">
            Privacy Policy
          </h1>
          <p className="text-xs text-[#8FA0B8]">Last updated: October 2025</p>
        </div>

        <div className="p-8 rounded-2xl bg-[#0c1a2d] border border-[#1b2f4a] space-y-6 text-sm leading-relaxed text-[#D5DFEC]">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">1. Introduction</h2>
            <p>
              {companyInfo.name} ("we", "our", or "us") respects your privacy and is committed to protecting the personal and proprietary information you share with us. This Privacy Policy outlines our practices regarding data collection, usage, and protection when you visit our website or interact with our software services.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">2. Information We Collect</h2>
            <p>
              We collect information that you voluntarily provide when requesting consultations, submitting inquiries, or communicating with our team. This includes your name, business email address, phone number, company name, and project specifications.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">3. How We Use Your Information</h2>
            <ul className="list-disc pl-5 space-y-1 text-xs sm:text-sm text-[#8FA0B8]">
              <li>To evaluate technical project feasibility and prepare customized proposals</li>
              <li>To communicate regarding scheduled consultation sessions</li>
              <li>To deliver agreed-upon software engineering, maintenance, and marketing services</li>
              <li>To comply with applicable legal obligations and industry standards</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">4. Confidentiality & Non-Disclosure (NDA)</h2>
            <p>
              We treat all project concepts, codebases, architectural designs, and client proprietary information with strict confidentiality. All client engagements are protected by mutual non-disclosure agreements. We never sell, lease, or monetize your contact or business data.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-white">5. Contact Information</h2>
            <p>
              For privacy inquiries, contact our Data Governance Officer at{' '}
              <a href={`mailto:${companyInfo.contact.email}`} className="text-[#159DE8] underline">
                {companyInfo.contact.email}
              </a>{' '}
              or reach our direct telephone line at {companyInfo.contact.phoneDisplay}.
            </p>
          </section>
        </div>

      </div>
    </div>
  );
};
